import { IconCurrencyRupee, IconReceiptRupee, IconX } from '@tabler/icons-react';
import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'sonner';
import { getApi, postApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import AddBankModal from './AddBankModal';

const WithdrawModal = ({ callback, settingData, currentBalance }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => {
        setBankDetails(null);
        setShow(false);
    };

    const handleShow = () => setShow(true);

    const [bankDetails, setBankDetails] = useState(null);

    const getBankDetails = async () => {
        if (currentBalance >= settingData?.minWithdrawForReward) {
            loadingShow();
            let resp = await getApi(urlApi.getCurrentBankDetails);
            loadingHide();
            handleShow();
            if (resp.responseCode === 200) {
                setBankDetails(resp?.data);
            } else {
                toast.error(resp?.message);
            }
        } else {
            toast.warning('Insufficient balance for withdrawal');
        }
    }


    async function submit() {
        let amount = document.getElementById("amount").value?.trim();
        if (amount) {
            loadingShow();
            let resp = await postApi({ amount: amount }, urlApi.withdrawReward);
            loadingHide();
            if (resp.responseCode === 200) {
                toast.success(resp?.message);
                if (callback) {
                    callback();
                }
                handleClose();
            } else {
                toast.error(resp?.message);
            }
        } else {
            toast.warning('Please enter amount');
            return;
        }
    }

    return (
        <>
            <button onClick={getBankDetails} className='text-sm font-semibold !bg-primary px-4 py-2 text-white rounded-full flex items-center gap-2'> <IconReceiptRupee size={18} /> Withdraw Now</button>
            <Modal show={show} onHide={handleClose} centered backdrop="static" >
                <Modal.Body className='rounded-xl p-0'>
                    <div className="flex justify-between items-center pt-3 px-4">
                        <p className="text-md font-semibold mb-0">Withdrawal</p>
                        <button onClick={handleClose}> <IconX /></button>
                    </div>
                    <hr className='my-2' />

                    <div className='px-3 py-2 pb-4'>
                        <div className='text-center'>
                            {bankDetails ? <p className='mb-2 text-sm text-gray-600'>Your withdraw will reflect to Account Number of - <b className='text-gray-900 text-md'>{bankDetails?.accountNumber}</b> by the name of <b className='text-gray-900 text-md'>{bankDetails?.accountHolderName}</b></p> : <p className='mb-2 text-sm text-gray-600'>You don't provide a bank details , please add bank details to withdraw</p>}
                        </div>
                        <div className='mb-0'>
                            <label htmlFor="amount" className='text-sm font-semibold !mb-2'>Amount</label>
                            <div className='flex !border rounded-full px-3 py-2 items-center'>
                                <IconCurrencyRupee color='#BDBDBD' size={20} />
                                <input type='text' id='amount' className='w-full px-2 py-2 text-sm bg-transparent focus:border-none focus:outline-none' disabled={!bankDetails} />
                            </div>
                        </div>
                    </div>

                    <hr className='my-3' />
                    <div className='flex justify-between gap-3 px-3 py-2'>
                        <button className='modal-cancel-btn' onClick={handleClose}>Cancel</button>
                        {
                            bankDetails ? <button className='primary-btn' onClick={() => submit()}>Withdraw</button> : <AddBankModal callback={() => getBankDetails()} />
                        }

                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default WithdrawModal